/* ---------------------------------------------------------------------
   Paging a listing without leaving it.

   The page links under a collection grid were ordinary links: every
   click reloaded the whole page and landed the shopper at the top, above
   the banner and the filters, with the browser's own flash in between.

   Now the click fetches just that section's next page (Shopify's Section
   Rendering API: the same URL with ?section_id=<this section>), swaps
   the grid and the pager in place, and scrolls smoothly to the top of
   the grid so the first new product is where the eye already is. The
   address bar still moves to ?page=N, so the page can be shared or
   reloaded, and Back/Forward walk the pages the same way.

   Nothing else changes hands: hearts, (+) buttons and the rest are
   delegated on the document already, and the wishlist is asked to
   re-mark the fresh cards. Anything that goes wrong falls back to the
   plain link.
--------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__vroPageSwap) return;
  window.__vroPageSwap = true;

  var LINKS = '.clp-pagination a.clp-page-link, .plp-pagination a.plp-page-link';
  var WRAPS = '.clp-grid-wrap, .plp-grid-wrap';
  var busy = false;
  var pushed = false;

  function sectionIdOf(el) {
    var s = el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : null;
  }
  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  /* Where the grid starts, less whatever stays pinned above it. */
  function topOf(wrap) {
    var offset = 16;
    var pinned = document.querySelectorAll('.clp-filterbar, .plp-filterbar, .site-header, .site-mobile-topbar');
    for (var i = 0; i < pinned.length; i++) {
      var cs = window.getComputedStyle(pinned[i]);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && cs.display !== 'none') {
        offset += pinned[i].getBoundingClientRect().height;
      }
    }
    return Math.max(0, wrap.getBoundingClientRect().top + window.pageYOffset - offset);
  }

  function swap(url, wrap, push) {
    var sectionId = sectionIdOf(wrap);
    if (!sectionId || !window.fetch || !window.DOMParser) { window.location.href = url; return; }
    busy = true;
    wrap.classList.remove('is-swapped');
    wrap.classList.add('is-swapping');
    wrap.style.minHeight = wrap.offsetHeight + 'px';
    wrap.setAttribute('aria-busy', 'true');
    window.scrollTo({ top: topOf(wrap), behavior: reduced() ? 'auto' : 'smooth' });

    var u = new URL(url, window.location.href);
    u.searchParams.set('section_id', sectionId);
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(WRAPS);
        if (!fresh) throw new Error('no grid in response');
        wrap.innerHTML = fresh.innerHTML;
        if (push) { history.pushState({ vroPageSwap: true }, '', url); pushed = true; }
        wrap.style.minHeight = '';
        wrap.removeAttribute('aria-busy');
        wrap.classList.remove('is-swapping');
        wrap.classList.add('is-swapped');
        setTimeout(function () { wrap.classList.remove('is-swapped'); }, 500);
        if (window.VroWishlist && window.VroWishlist.sync) { try { window.VroWishlist.sync(); } catch (e) { /* ignore */ } }
        document.dispatchEvent(new CustomEvent('vro:grid:swapped', { detail: { wrap: wrap, url: url } }));
        busy = false;
      })
      .catch(function () { window.location.href = url; });
  }

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest(LINKS) : null;
    if (!link) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var wrap = link.closest(WRAPS);
    if (!wrap || !link.getAttribute('href')) return;
    e.preventDefault();
    if (busy) return;
    swap(link.href, wrap, true);
  });

  window.addEventListener('popstate', function () {
    if (!pushed) return;
    var wrap = document.querySelector(WRAPS);
    if (!wrap) return;
    swap(window.location.href, wrap, false);
  });
})();
